var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Component } from 'vue-property-decorator';
import PersonnelExpensesControl from '@/template/components/aidApplication/budgetaryEstimate/expenses/PersonnelExpensesControl.vue';
import AttachmentRow from '@/common/components/AttachmentRow.vue';
import PlainTextControl from '@/common/components/PlainTextControl.vue';
import EstimatesAndDetailsControl from '@/template/components/aidApplication/budgetaryEstimate/EstimatesAndDetailsControl.vue';
import EstimatesControl from '@/template/components/aidApplication/budgetaryEstimate/EstimatesControl.vue';
import LineControl from '@/common/components/LineControl.vue';
import LineControlWrapper from '@/common/types/LineControlWrapper';
import LineControlConfig from '@/common/types/LineControlConfig';
import LineItemConfig from '@/common/types/LineItemConfig';
import AmountItemConfig from '@/common/types/AmountItemConfig';
import Estimates from '@/common/types/Estimates';
import InvestmentBudgetaryEstimateBase from './InvestmentBudgetaryEstimateBase';
var IctBudgetaryEstimateView = /** @class */ (function (_super) {
    __extends(IctBudgetaryEstimateView, _super);
    function IctBudgetaryEstimateView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(IctBudgetaryEstimateView.prototype, "model", {
        get: function () {
            return this.item.ict;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IctBudgetaryEstimateView.prototype, "projectExpenses", {
        get: function () {
            var e_1, _a;
            var showRowTotal = true;
            var showColTotal = true;
            var showActions = false;
            var maxRows = null;
            var config = new LineControlConfig(showRowTotal, showColTotal, showActions, this.createNewLineItem, maxRows);
            var personnelConfig = new LineItemConfig();
            var personnel = new Estimates(this.model.personnelExpenses.yearlyPersonnelExpenses);
            var _loop_1 = function (year) {
                personnelConfig.addAmountItemConfig(year.toString(), new AmountItemConfig(function () { return personnel.yearlyTotal(year); }));
            };
            try {
                for (var _b = __values(personnel.years), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var year = _c.value;
                    _loop_1(year);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            config.addLineItemConfig("BudgetaryEstimate.Investment.ICT.ProjectExpenses.Personnel", personnelConfig);
            return new LineControlWrapper(this.model.projectExpenses, config);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IctBudgetaryEstimateView.prototype, "totalExpensesItem", {
        get: function () {
            var e_2, _a;
            var expenses = this.projectExpenses.columnTotals;
            var expensesItem = {
                name: "BudgetaryEstimate.Total.Expenses",
                isReadOnly: true,
                yearlyItems: [],
                canDelete: false
            };
            try {
                for (var expenses_1 = __values(expenses), expenses_1_1 = expenses_1.next(); !expenses_1_1.done; expenses_1_1 = expenses_1.next()) {
                    var year = expenses_1_1.value;
                    expensesItem.yearlyItems.push({ year: parseInt(year.column.value), isReadOnly: true, isRequired: false, value: year.total });
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (expenses_1_1 && !expenses_1_1.done && (_a = expenses_1.return)) _a.call(expenses_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return expensesItem;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IctBudgetaryEstimateView.prototype, "totalProfitsItem", {
        get: function () {
            var e_3, _a;
            var profits = new Estimates(this.model.funding.breakdown);
            var profitsItem = {
                name: "BudgetaryEstimate.Investment.Total.Funding",
                isReadOnly: true,
                yearlyItems: [],
                canDelete: false
            };
            try {
                for (var _b = __values(profits.years), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var year = _c.value;
                    profitsItem.yearlyItems.push({ year: year, isReadOnly: true, isRequired: false, value: profits.yearlyTotal(year) });
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return profitsItem;
        },
        enumerable: false,
        configurable: true
    });
    IctBudgetaryEstimateView.prototype.computeTotalsYearlyTotal = function (year) {
        var value = this.totalProfitsItem.yearlyItems.find(function (x) { return x.year == year; }).value - this.totalExpensesItem.yearlyItems.find(function (x) { return x.year == year; }).value;
        return Number.isInteger(value) ? value : 0;
    };
    Object.defineProperty(IctBudgetaryEstimateView.prototype, "totalSummary", {
        /**
         * Calculates total expenses and profits
         */
        get: function () {
            return new Estimates([this.totalProfitsItem, this.totalExpensesItem], this.computeTotalsYearlyTotal);
        },
        enumerable: false,
        configurable: true
    });
    IctBudgetaryEstimateView = __decorate([
        Component({
            name: 'IctBudgetaryEstimateView',
            components: {
                PlainTextControl: PlainTextControl,
                AttachmentRow: AttachmentRow,
                PersonnelExpensesControl: PersonnelExpensesControl,
                EstimatesAndDetailsControl: EstimatesAndDetailsControl,
                EstimatesControl: EstimatesControl,
                LineControl: LineControl
            }
        })
    ], IctBudgetaryEstimateView);
    return IctBudgetaryEstimateView;
}(InvestmentBudgetaryEstimateBase));
export default IctBudgetaryEstimateView;
